import CryptoJS from 'crypto-js';

export default class UserIPTracking{
    constructor(){
        let userData = window.localStorage.getItem('accessuserdata');
        userData = CryptoJS.AES.decrypt(userData, 'Key');
        userData = JSON.parse(userData.toString(CryptoJS.enc.Utf8));

        this.projectname = "investigation";
        this.type = "web";
        this.userid = userData.userid;
        this.username = userData.username;
        this.olduserid = "";
        this.routeurl = "#";
        this.meta = "";
    }
    setProjectName(projectname){
      this.projectname = projectname;
      return this;
    }
  
    setType(type){
      this.type = type;
      return this;
    }
  
    setUserid(userId){
      this.userid = userId;
      return this;
    }
  
    setUserName(username){
      this.username = username;
      return this;
    }
  
    setoldUserId(oldUserid){
      this.olduserid = oldUserid;
      return this;
    }
  
    setRouteUrl(url){
      this.routeurl = url;
      return this;
    }
  
    setMeta(shipmentEvent, shippingID){
      this.meta = {
        "event" : shipmentEvent,
        "shipment" : shippingID
      };
      return this;
    }
  
    createObject(){
      return this;
    }
  
  }

  


// WEBPACK FOOTER //
// ./src/interface/userTracker.js